import { motion } from "framer-motion";
import { Award, Globe2 } from "lucide-react";
import { CPRES_BADGE_URL, ROG_WEST_LOGO_URL } from "@/lib/assets";

const BADGES = [
  { icon: null, label: "Probate Certified", sub: "California Certified Probate Real Estate Specialist (CPRES)", image: CPRES_BADGE_URL },
  { icon: Award, label: "Luxury Home Marketing", sub: "Institute for Luxury Home Marketing — Member" },
  { icon: Globe2, label: "National Network", sub: "Coast-to-coast referral coverage" },
  { icon: null, label: "Realty ONE Group WEST", sub: "Top 1% brokerage · Inc. 5000 for 7 years", image: ROG_WEST_LOGO_URL },
];

const PARTNERS = [
  "Zillow",
  "Trulia",
  "Homes.com",
  "Realtor.com",
  "Redfin",
  "MLS.com",
  "Realty ONE Group WEST",
  "ListHub",
  "CPRES",
  "NAR Realtor",
];

export default function TrustBadges() {
  return (
    <section id="trust" data-testid="trust-section" className="py-24 sm:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="section-overline">Credentials & Trust</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl text-navy-900 leading-tight tracking-tight">
            Vetted. Certified. <em className="italic text-gold-600">Trusted.</em>
          </h2>
        </div>

        {/* Badges */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {BADGES.map((b, i) => (
            <motion.div
              key={b.label}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`badge-${i}`}
              className="rounded-2xl border border-navy-100 bg-navy-50/50 p-6 hover:border-gold-400 hover:bg-white hover:shadow-md transition-all"
            >
              {b.image ? (
                <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-white p-1 shadow-md ring-1 ring-navy-900/5">
                  <img src={b.image} alt={b.label} className="h-full w-full object-contain rounded-full" />
                </div>
              ) : (
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy-900 text-gold-400">
                  <b.icon size={20} />
                </div>
              )}
              <div className="mt-4 font-heading text-base text-navy-900 font-semibold">{b.label}</div>
              <div className="text-xs text-navy-600 mt-1 leading-relaxed">{b.sub}</div>
            </motion.div>
          ))}
        </div>

        {/* Partner marquee */}
        <div className="mt-16 relative overflow-hidden py-6 border-y border-navy-100">
          <div className="flex animate-marquee gap-16 w-max">
            {[...PARTNERS, ...PARTNERS].map((p, i) => (
              <div key={i} className="text-navy-400 font-heading text-xl italic whitespace-nowrap tracking-wide hover:text-gold-600 transition-colors">
                {p}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
